'use client';

import React, { useEffect, useState } from 'react';
import { BACKEND_URL, FRONTEND_URL } from '@/utils/endpoints'; // your API base URL
import { Helmet } from 'react-helmet'; // To manage dynamic meta tags
import Image from 'next/image';
import styles from './styles.module.css';
import { FaFacebookF, FaTwitter, FaLinkedinIn } from 'react-icons/fa';
import * as Icons from 'react-icons/fa6';

function BadgeDetailPage({ params }) {
  const { id } = params;
  const [badge, setBadge] = useState(null);

  useEffect(() => {
    if (id) {
      // Fetch badge data using the badge ID from the API
      fetch(`${BACKEND_URL}/api/badges/fetch/${id}`)
        .then((response) => response.json())
        .then((data) => setBadge(data))
        .catch((error) => {
          Sentry.captureException(error);
          console.error('Error fetching badge:', error);
        });
    }
  }, [id]);

  if (!badge) return <p>Loading...</p>;

  const { name, description, imageUrl } = badge;
  const badgeImage = imageUrl || '/img/logo.png';
  const shareUrl = `${FRONTEND_URL}/badge/${id}`;

  // Social media share functions
  const handleFacebookShare = () => {
    const url = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
      shareUrl
    )}`;
    window.open(url, '_blank', 'width=600,height=400');
  };

  const handleLinkedInShare = () => {
    const url = `https://www.linkedin.com/shareArticle?url=${encodeURIComponent(
      shareUrl
    )}`;
    window.open(url, '_blank', 'width=600,height=400');
  };

  const handleTwitterShare = () => {
    const text = encodeURIComponent(`Check out this badge: ${name}`);
    const url = `https://twitter.com/intent/tweet?text=${text}&url=${encodeURIComponent(
      shareUrl
    )}`;
    window.open(url, '_blank', 'width=600,height=400');
  };

  // Copy link to clipboard and show toast message

  return (
    <div className={styles.badgeDetailPage}>
      <Helmet>
        <meta property="og:title" content={name ?? ''} />
        <meta property="og:description" content={description ?? ''} />
        <meta property="og:image" content={badgeImage} />
        <meta
          property="og:url"
          content={`https://your-domain.com/badge/${id}`}
        />
      </Helmet>

      <div className={styles.badgeDetailContent}>
        <DynamicFaIcon iconName={badge?.icon} />
        <h1>{name}</h1>
        <Image
          src={badgeImage}
          alt={name ?? ''}
          width={200}
          height={200}
          className={styles.badgeImage}
        />
        <p>{description}</p>

        {/* Social media share buttons */}
        <div className={styles.socialShareIcons}>
          <FaFacebookF className={styles.icon} onClick={handleFacebookShare} />
          <FaTwitter className={styles.icon} onClick={handleTwitterShare} />
          <FaLinkedinIn className={styles.icon} onClick={handleLinkedInShare} />
        </div>

        {/* "Start your own journey" Button */}
        <button
          className={styles.startJourneyButton}
          onClick={() => (window.location.href = '/')}
        >
          Start your own journey
        </button>
      </div>
    </div>
  );
}

function DynamicFaIcon({ iconName }) {
  const formattedIconName = iconName
    ?.split('-')
    ?.map((word, index) =>
      index === 0 ? word : word?.charAt(0)?.toUpperCase() + word?.slice(1)
    )
    ?.join('');

  const IconComponent =
    Icons[
      `Fa${
        formattedIconName?.charAt(0)?.toUpperCase() + formattedIconName?.slice(1)
      }`
    ];

  if (!IconComponent) {
    return null;
  }

  return <IconComponent />;
}

export default BadgeDetailPage;
